import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ContactForm from './components/ContactForm';
import Home from './pages/Home';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import './App.css';

function App() {
  const [isContactFormOpen, setIsContactFormOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState('core');

  const openContactForm = () => setIsContactFormOpen(true);
  const closeContactForm = () => setIsContactFormOpen(false);

  return (
    <Router>
      <div className="App">
        <Header onContactClick={openContactForm} />
        <main>
          <Routes>
            <Route
              path="/"
              element={
                <Home
                  selectedProduct={selectedProduct}
                  onProductChange={setSelectedProduct}
                  onContactClick={openContactForm}
                />
              }
            />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
          </Routes>
        </main>
        <Footer selectedProduct={selectedProduct} />
        <ContactForm isOpen={isContactFormOpen} onClose={closeContactForm} />
      </div>
    </Router>
  );
}

export default App;
